import roles from '../config/constants/roles.json'
import map from "lodash/map";
import {useAccount} from "wagmi";

export enum Permissions {
  ADMIN = "admin",
  STAFF = "staff",
  INVESTOR = "investor",
  STATISTICS = "statistics"
}

export function hasCurrentWalletPermission(address, rolesToCheck: Permissions[]): boolean {
  // const {address} = useAccount()
  if (!address) {
    return false
  }
  return hasPermission(rolesToCheck, address)
}

export function hasPermission(rolesToCheck: Permissions[], address: string): boolean {
  try {
    let hasPermission = false
    map(rolesToCheck, (role) => {
      // check if address is admin role and return true regardless
      const adminRoleConfig = roles[Permissions.ADMIN]
      if (addressInList(adminRoleConfig, address)) {
        hasPermission = true
      }

      // check if any role applies
      const roleConfig = roles[role]
      return hasPermission = hasPermission || addressInList(roleConfig, address)
    })
    return hasPermission
  } catch (e) {
    console.error(e)
  }
}

const addressInList = (addressList: string[], address: string): boolean => {
  let containsAddress = false
  addressList.map(encodedAddress => {
    if (atob(encodedAddress) === address) {
      containsAddress = true
    }
  })
  return containsAddress
}
